import MaterialNameStack from '#/modules/imsMgmt/receipts/shared/MaterialNameStack';
import { getInvStockAvailableQty } from '#/modules/imsMgmt/receipts/stockTransfer/helper/formSerialize';

function formatWarehouseLocation(row) {
  const warehouse = row?.warehouse;
  if (!warehouse) {
    return '-';
  }

  const warehouseLabel = [warehouse.code, warehouse.name].filter(Boolean).join(' ')
    || warehouse.id
    || '-';
  const location = warehouse.location;
  const locationLabel = location
    ? ([location.code, location.name].filter(Boolean).join(' ') || '')
    : '';

  return locationLabel ? `${warehouseLabel} / ${locationLabel}` : warehouseLabel;
}

/**
 * 工單退料掃碼列：左＝庫編／倉別＋物料；右＝可用量（刪除由 ScanCodeDialog 負責）。
 */
export function renderStockReturnScannedRow(row) {
  const availableQty = getInvStockAvailableQty(row);
  return (
    <div className="min-w-0 w-full flex items-center justify-between gap-3">
      <div className="min-w-0 flex flex-wrap items-center gap-x-5 gap-y-1">
        <div className="min-w-0 shrink-0">
          <p className="font-mono text-sm font-medium text-slate-800">
            {row.stockNo || '—'}
          </p>
          <p className="truncate text-xs text-muted-foreground">
            {formatWarehouseLocation(row)}
          </p>
        </div>
        <MaterialNameStack
          name={row.mtr?.name}
          code={row.mtr?.mtrNo}
        />
      </div>
      <p className="shrink-0 text-right text-sm text-muted-foreground">
        可用量：
        <span className="text-base font-medium text-slate-800 tabular-nums">
          {availableQty || '—'}
        </span>
      </p>
    </div>
  );
}

export function renderStockReturnAmbiguousRow(row) {
  const availableQty = getInvStockAvailableQty(row);
  return (
    <div className="min-w-0 space-y-1">
      <p className="font-mono text-sm font-medium text-slate-800">
        {row.stockNo || '—'}
      </p>
      <p className="text-xs text-muted-foreground">
        {formatWarehouseLocation(row)}
      </p>
      <MaterialNameStack
        name={row.mtr?.name}
        code={row.mtr?.mtrNo}
      />
      <p className="text-xs text-muted-foreground">
        可用量：
        {availableQty || '—'}
      </p>
    </div>
  );
}
